import type { FC } from "react";
import Typography from "@mui/material/Typography";
import { Translate } from "@privacy/translations";
import type { RegistrationById } from "../api/registrations.types";
import { Strong } from "../shared/Strong";

export const ManagedByLine: FC<{ registration: RegistrationById }> = ({ registration }) => {
  const editability = registration.organisationEditability;
  if (!editability?.isCustomerManaged || !editability.managedBy) return null;

  const responsible = editability.customerResponsible;

  return (
    <Typography
      sx={theme => ({
        mt: "4px",
        fontSize: theme.typography.pxToRem(14),
        lineHeight: 1.5,
        color: "text.secondary",
        overflowWrap: "anywhere",
      })}
    >
      <Translate
        translationKey="RegistrationGrid.Drawer.InfoAlert.CustomerManaged"
        values={{ customer: <Strong>{editability.managedBy.name}</Strong> }}
      />
      {responsible && ` (${responsible.firstName} ${responsible.lastName})`}
    </Typography>
  );
};
